<!-- =========================================================================================
	File Name: ItemGridView.vue
	Description: Item Component - Grid VIew
	----------------------------------------------------------------------------------------
	Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
	Author: Pixinvent
	Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>

  <vx-card class="grid-view-item mb-base overflow-hidden mb-5">
    <div slot="no-body">
      <img class="responsive cursor-pointer card-img-top"
           :src="classRoomPictureCompute"
           @click="navigateToEditCourse"
           alt="content-img">

    </div>

    <div class="flex justify-between flex-wrap center" >
      <h5 class="mb-2 cursor-pointer hover:text-primary"
          @click="navigateToEditCourse">
        {{ item.subject.code }}
      </h5>

      <vs-chip transparent color="primary" >
        <vs-avatar class="bg-primary cursor-default" :text="credit"/>
        {{ $t('student-enroll.credit') }}
      </vs-chip>
    </div>

    <p class="text-grey">{{ item.subject.nameLocal }}</p>

    <div class="flex justify-between flex-wrap mt-2">
      <!--<span class="flex items-center">
        {{ $t('student-enroll.section-no') }} {{ item.sectionNo }}
      </span>

      <span class="flex items-center mr-2">
        {{ $t('student-enroll.learn-span-no') }} {{ getClassSection(item) }}
      </span>-->
    </div>

    <vs-divider/>

    <div class="flex justify-between flex-wrap center mt-2 ">

      <vs-button
        @click="navigateToEditCourse"
        class="mr-2 shadow-lg card-button"
        type="gradient" color="#7367F0" gradient-color-secondary="#CE9FFC">
        <span>{{ $t('student-assignment.desc') }}</span>
      </vs-button>

      <vs-button
        @click="navigateToEditVdoSet"
        class="mr-2 shadow-lg card-button"
        type="gradient" color="success">
        <span>{{ $t('class-room.vdo-set') }}</span>
      </vs-button>
<!--      <vs-button
        @click="navigateToVirtualClassExample"
        class="mr-2 shadow-lg card-button"
        type="gradient" color="success">
        <span>{{ $t('teacher-dash-board.virtual-class-example') }}</span>
      </vs-button>-->
    </div>

    <!--SLOT: ACTION BUTTONS -->
    <slot name="action-buttons"/>

  </vx-card>

</template>

<script>
  import {state} from '../data';
  import {config, getClassRoomUrl} from "@/utils/upload";

  export default {
    props: {
      item: {
        type: Object,
        required: true
      },
    },
    data(){
      return {
        local: state.local,

        classRoomPicture: this.getClassRoomPicture(this.item),
      }
    },
    computed: {
      classRoomPictureCompute(){
        return this.classRoomPicture;
      },
      credit(){
        if(this.item.subject){
          return String(this.item.subject.creditCalGrade)
        }
        return '-';
      }
    },
    methods: {
      //---------------------------------------- Event Function ------------------------------------------------------//
      navigateToEditCourse() {
        this.$router.push(
          {
            name: "course-outline-edit",
            params: {
              id: this.item.id,
            }
          }
        )
      },
      navigateToEditVdoSet() {
        this.$router.push({
          name: 'vdo-set-edit',
          params: {
            courseOutlineId: this.item.id,
          }
        });
      },
      navigateToVirtualClassExample(){
        this.$router.push({
          path: `/e-learning/virtual-class/${this.item.id}`,
          params: {
            courseOutlineId: this.item.id,
            classSectionId: this.item.id,
          }
        });
      },
      //---------------------------------------- Local Function ------------------------------------------------------//
      getClassRoomPicture(item){
        if(item.picturePath){
          return getClassRoomUrl(item.picturePath);
        }else{

          if(state.local.classRoomPlaceholderIndex >= 10){
            state.local.classRoomPlaceholderIndex = 0;
          }
          state.local.classRoomPlaceholderIndex = state.local.classRoomPlaceholderIndex + 1;

          return config.baseUrl + 'static/images/classroom-placeholder-' + state.local.classRoomPlaceholderIndex + '.jpeg';
        }
      },
    }
  }
</script>

<style lang="scss" scoped>
  .grid-view-item {
    .grid-view-img {
      max-width: 100%;
      max-height: 100%;
      width: auto;
      transition: .35s;
    }

    &:hover {
      transform: translateY(-5px);
      box-shadow: 0px 4px 25px 0px rgba(0,0,0,.25);

      .grid-view-img{
        opacity: 0.9;
      }
    }
  }
</style>
